var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "socialMedia" }, [
    _c("h2", [_vm._v("Verknüpfte Profile")]),
    _vm._v(" "),
    _vm.readonly
      ? _c("div", [
          _vm.visible("instagram")
            ? _c("div", [
                _vm.instagramAccount
                  ? _c(
                      "div",
                      [
                        _vm._m(0),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "content-item verticalAlignTop lightGrey"
                          },
                          [_vm._v(_vm._s(_vm.instagramAccount.url))]
                        ),
                        _vm._v(" "),
                        _vm.instagramAccount
                          ? _c("profileItemVisibilityEditor", {
                              attrs: {
                                item: _vm.profileitems.instagram.url,
                                readOnly: _vm.readonly
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.visible("twitter")
            ? _c("div", [
                _vm.twitterAccount
                  ? _c(
                      "div",
                      [
                        _vm._m(1),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "content-item verticalAlignTop lightGrey"
                          },
                          [_vm._v(_vm._s(_vm.twitterAccount.url))]
                        ),
                        _vm._v(" "),
                        _vm.twitterAccount
                          ? _c("profileItemVisibilityEditor", {
                              attrs: {
                                item: _vm.profileitems.twitter.url,
                                readOnly: _vm.readonly
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ])
            : _vm._e()
        ])
      : _c("div", [
          _vm.errorMessage
            ? _c("p", { staticClass: "errorText" }, [
                _vm._v(
                  "\n\t            " + _vm._s(_vm.errorMessage) + "\n\t        "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.removeSuccessful
            ? _c(
                "p",
                {
                  staticClass: "errorText",
                  staticStyle: { "margin-top": "15px" }
                },
                [
                  _vm._v(
                    "\n\t            Verknüpfung erfolgreich entfernt\n\t        "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.connectSuccessful
            ? _c(
                "p",
                {
                  staticClass: "errorText",
                  staticStyle: { "margin-top": "15px" }
                },
                [
                  _vm._v(
                    "\n\t            Verknüpfung erfolgreich hergestellt\n\t        "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.visible("instagram")
            ? _c(
                "div",
                [
                  _c(
                    "div",
                    { staticClass: "label-item verticalAlignTop black500" },
                    [_c("span", [_vm._v("Instagram")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "content-item verticalAlignTop lightGrey" },
                    [
                      _vm.instagramAccount
                        ? _c("div", [
                            _c("div", [
                              _vm._v(_vm._s(_vm.instagramAccount.url))
                            ]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.remove("INSTAGRAM")
                                  }
                                }
                              },
                              [_vm._v("Verknüpfung löschen")]
                            )
                          ])
                        : _c("div", [
                            _c(
                              "a",
                              {
                                attrs: { target: "_blank" },
                                on: {
                                  click: function($event) {
                                    _vm.connect("INSTAGRAM")
                                  }
                                }
                              },
                              [_vm._v("Jetzt verknüpfen")]
                            )
                          ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm.instagramAccount
                    ? _c("profileItemVisibilityEditor", {
                        attrs: {
                          item: _vm.profileitems.instagram.url,
                          readOnly: _vm.readonly
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticStyle: { clear: "both" } })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.visible("twitter")
            ? _c(
                "div",
                [
                  _c(
                    "div",
                    { staticClass: "label-item verticalAlignTop black500" },
                    [_c("span", [_vm._v("Twitter")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "content-item verticalAlignTop lightGrey" },
                    [
                      _vm.twitterAccount
                        ? _c("div", [
                            _c("div", [_vm._v(_vm._s(_vm.twitterAccount.url))]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.remove("TWITTER")
                                  }
                                }
                              },
                              [_vm._v("Verknüpfung löschen")]
                            )
                          ])
                        : _c("div", [
                            _c(
                              "a",
                              {
                                attrs: { target: "_blank" },
                                on: {
                                  click: function($event) {
                                    _vm.connect("TWITTER")
                                  }
                                }
                              },
                              [_vm._v("Jetzt verknüpfen")]
                            )
                          ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm.twitterAccount
                    ? _c("profileItemVisibilityEditor", {
                        attrs: {
                          item: _vm.profileitems.twitter.url,
                          readOnly: _vm.readonly
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticStyle: { clear: "both" } })
                ],
                1
              )
            : _vm._e()
        ]),
    _vm._v(" "),
    _c("h2", [_vm._v("Manuell eingetragene Profile")])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "label-item verticalAlignTop black500" }, [
      _c("span", [_vm._v("Instagram")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "label-item verticalAlignTop black500" }, [
      _c("span", [_vm._v("Twitter")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-573da87a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-573da87a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfileSocialMediaConnector.vue
// module id = 580
// module chunks = 2